<template>
    <div>
        <span v-if="calc.changeLog">
            <p
                class="
                    text-title-large
                    font-weight-medium
                    text-typography1
                    pb-4
                "
            >
                Changelog
            </p>
            <div v-for="(a, i) in calc.changeLog.slice().reverse()" :key="i">
                <p class="text-title-small" style="margin-bottom: 5px">
                    {{ a.revision }}
                </p>
                <p>{{ a.description }}</p>
            </div>
        </span>
        <span v-else-if="calc.revisions">
            <p class="text-title-large font-weight-medium text-typography1">
                Revisions
            </p>
            <ul>
                <li v-for="(a, i) in calc.revisions" :key="i">v{{ a }}</li>
            </ul>
        </span>
        <p v-else class="text-body-large text-typography1">
            This calculation has no revisions.
        </p>
    </div>
</template>
<script setup>
defineProps(['calc'])
</script>
